import { NormalBrowseFileInputFiled, NormalTextInputField } from "@/components";
import React, { useMemo } from "react";

const StartYourBusinessInfoSection = ({
  activeLang,
  isFetching,
  allFilesResponse,
  searchValue,
  selectedFileType,
  onChangeImage,
  handleTextInputChange,
  stateDetails,
  adminRole,
  permissionsList,
}) => {
  const isNonTranslatableField = useMemo(() => {
    return activeLang === "en" ? true : false;
  }, [activeLang]);

  const getSelectedInfoImageId = (id) => {
    if (id) {
      onChangeImage("start-your-business-section-2-info-image", id);
    } else {
      onChangeImage("start-your-business-section-2-info-image", "");
    }
  };

  return (
    <>
      {/* Info Image */}
      {isNonTranslatableField && (
        <NormalBrowseFileInputFiled
          isFetching={isFetching}
          labelText="Info Image"
          fieldId="start-your-business-section-2-info-image"
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImageFunction={getSelectedInfoImageId}
          selectedFileId={
            stateDetails?.["start-your-business-section-2-info-image"] || ""
          }
          adminRole={adminRole}
          permissionsList={permissionsList}
          infoText="Recommended size: 1300 x 650px"
          extraContainerClasses="mb-5"
        />
      )}

      {/* Info Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="start-your-business-section-2-info-heading"
        fieldName="start-your-business-section-2-info-heading"
        placeholderText="Heading"
        inputValue={
          stateDetails?.["start-your-business-section-2-info-heading"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
        extraContainerClasses="mb-5"
      />

      {/* Info Description */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Description"
        fieldId="start-your-business-section-2-info-description"
        fieldName="start-your-business-section-2-info-description"
        placeholderText="Description"
        inputValue={
          stateDetails?.["start-your-business-section-2-info-description"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
        extraContainerClasses="mb-5"
      />
    </>
  );
};

export default StartYourBusinessInfoSection;
